import commonJsModule from "inject-body-webpack-plugin"

export default commonJsModule.default